module.exports = {
	"stations": {
		"generated_at": 1573211485,
		"stations": [
			{
				"active": true,
				"city": "Sharjah",
				"company_name": "",
				"country": "United Arab Emirates",
				"elevation": 4.142638,
				"gateway_id": 8422665,
				"gateway_id_hex": "001D0A808509",
				"imei": "359180084022794",
				"latitude": 25.35156,
				"longitude": 55.39328,
				"private": false,
				"product_number": "6801",
				"recording_interval": 15,
				"region": "Sharjah",
				"registered_date": 1571917065,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah",
				"subscription_end_date": 1603539465,
				"time_zone": "Asia/Dubai",
				"user_email": "Jeroen.Janssen@AKT-UK.COM",
				"username": "DGSharjah"
			}
		]
	},
	"nodes": {
		"generated_at": 1573220305,
		"nodes": [
			{
				"active": true,
				"device_id": 9569897,
				"device_id_hex": "001D0A920669",
				"elevation": 0,
				"firmware_version": 0,
				"latitude": 25.346254,
				"longitude": 55.420933,
				"node_id": 82250,
				"node_name": "Node 1",
				"registered_date": 1571920211,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			},
			{
				"active": true,
				"device_id": 9570307,
				"device_id_hex": "001D0A920803",
				"elevation": 0,
				"firmware_version": 0,
				"latitude": 25.346254,
				"longitude": 55.420933,
				"node_id": 82430,
				"node_name": "Node 2",
				"registered_date": 1572261110,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			},
			{
				"active": true,
				"device_id": 9569775,
				"device_id_hex": "001D0A9205EF",
				"elevation": 0,
				"firmware_version": 0,
				"latitude": 25.346254,
				"longitude": 55.420933,
				"node_id": 82432,
				"node_name": "Node 3",
				"registered_date": 1572262399,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			}
		]
	},
	"sensors": {
		"generated_at": 1573253942,
		"sensors": [
			{
				"active": true,
				"category": "HEALTH",
				"created_date": 1571920211,
				"elevation": 0,
				"latitude": 25.346254,
				"longitude": 55.420933,
				"lsid": 265130,
				"manufacturer": "Davis Instruments",
				"modified_date": 1571920211,
				"parent_device_id": 9569897,
				"parent_device_id_hex": "001D0A920669",
				"parent_device_name": "Node 1",
				"parent_device_type": "Node",
				"port_number": 0,
				"product_name": "Node Health",
				"product_number": "6810",
				"rain_collector_type": 0,
				"sensor_type": 501,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			},
			{
				"active": true,
				"category": "HEALTH",
				"created_date": 1572261110,
				"elevation": 0,
				"latitude": 25.346254,
				"longitude": 55.420933,
				"lsid": 265815,
				"manufacturer": "Davis Instruments",
				"modified_date": 1572261110,
				"parent_device_id": 9570307,
				"parent_device_id_hex": "001D0A920803",
				"parent_device_name": "Node 2",
				"parent_device_type": "Node",
				"port_number": 0,
				"product_name": "Node Health",
				"product_number": "6810",
				"rain_collector_type": 0,
				"sensor_type": 501,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			},
			{
				"active": true,
				"category": "HEALTH",
				"created_date": 1572262399,
				"elevation": 0,
				"latitude": 25.346254,
				"longitude": 55.420933,
				"lsid": 265823,
				"manufacturer": "Davis Instruments",
				"modified_date": 1572262399,
				"parent_device_id": 9569775,
				"parent_device_id_hex": "001D0A9205EF",
				"parent_device_name": "Node 3",
				"parent_device_type": "Node",
				"port_number": 0,
				"product_name": "Node Health",
				"product_number": "6810",
				"rain_collector_type": 0,
				"sensor_type": 501,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			},
			{
				"active": true,
				"category": "HEALTH",
				"created_date": 1571917065,
				"elevation": 4.142638,
				"latitude": 25.35156,
				"longitude": 55.39328,
				"lsid": 265117,
				"manufacturer": "Davis Instruments",
				"modified_date": 1571917065,
				"parent_device_id": 8422665,
				"parent_device_id_hex": "001D0A808509",
				"parent_device_name": "Drought Garden Sharjah",
				"parent_device_type": "Gateway",
				"port_number": 0,
				"product_name": "Gateway HSPA Health",
				"product_number": "6801",
				"rain_collector_type": 0,
				"sensor_type": 502,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			},
			{
				"active": true,
				"category": "ISS",
				"created_date": 1571917587,
				"elevation": 4.142638,
				"latitude": 25.35156,
				"longitude": 55.39328,
				"lsid": 265115,
				"manufacturer": "Davis Instruments",
				"modified_date": 1571917587,
				"parent_device_id": 8422665,
				"parent_device_id_hex": "001D0A808509",
				"parent_device_name": "Drought Garden Sharjah",
				"parent_device_type": "Gateway",
				"port_number": 9,
				"product_name": "GroWeather 24-Hr Fan Metric",
				"product_number": "6825CM",
				"rain_collector_type": 2,
				"sensor_type": 26,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			},
			{
				"active": true,
				"category": "Solar Radiation",
				"created_date": 1571917587,
				"elevation": 4.142638,
				"latitude": 25.35156,
				"longitude": 55.39328,
				"lsid": 265116,
				"manufacturer": "Davis Instruments",
				"modified_date": 1571917587,
				"parent_device_id": 8422665,
				"parent_device_id_hex": "001D0A808509",
				"parent_device_name": "Drought Garden Sharjah",
				"parent_device_type": "Gateway",
				"port_number": -1,
				"product_name": "Solar Radiation",
				"product_number": "",
				"rain_collector_type": 0,
				"sensor_type": 4,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			},
			{
				"active": true,
				"category": "Barometer",
				"created_date": 1571917671,
				"elevation": 4.142638,
				"latitude": 25.35156,
				"longitude": 55.39328,
				"lsid": 265118,
				"manufacturer": "Davis Instruments",
				"modified_date": 1571917671,
				"parent_device_id": 8422665,
				"parent_device_id_hex": "001D0A808509",
				"parent_device_name": "Drought Garden Sharjah",
				"parent_device_type": "Gateway",
				"port_number": 10,
				"product_name": "Barometer",
				"product_number": "",
				"rain_collector_type": 0,
				"sensor_type": 3,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			},
			{
				"active": true,
				"category": "Soil Moisture",
				"created_date": 1571921174,
				"elevation": 0,
				"latitude": 25.346254,
				"longitude": 55.420933,
				"lsid": 265131,
				"manufacturer": "Decagon",
				"modified_date": 1571921174,
				"parent_device_id": 9569897,
				"parent_device_id_hex": "001D0A920669",
				"parent_device_name": "Node 1",
				"parent_device_type": "Node",
				"port_number": 1,
				"product_name": "5TM",
				"product_number": "",
				"rain_collector_type": 0,
				"sensor_type": 112,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			},
			{
				"active": true,
				"category": "Leaf Wetness",
				"created_date": 1571922151,
				"elevation": 0,
				"latitude": 25.346254,
				"longitude": 55.420933,
				"lsid": 265136,
				"manufacturer": "Davis Instruments",
				"modified_date": 1571922151,
				"parent_device_id": 9569897,
				"parent_device_id_hex": "001D0A920669",
				"parent_device_name": "Node 1",
				"parent_device_type": "Node",
				"port_number": 2,
				"product_name": "Leaf Wetness Sensor",
				"product_number": "6420",
				"rain_collector_type": 0,
				"sensor_type": 104,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			},
			{
				"active": true,
				"category": "Temp/Hum",
				"created_date": 1571922265,
				"elevation": 0,
				"latitude": 25.346254,
				"longitude": 55.420933,
				"lsid": 265139,
				"manufacturer": "Davis Instruments",
				"modified_date": 1571922265,
				"parent_device_id": 9569897,
				"parent_device_id_hex": "001D0A920669",
				"parent_device_name": "Node 1",
				"parent_device_type": "Node",
				"port_number": 3,
				"product_name": "Temp/Hum Sensor",
				"product_number": "6830",
				"rain_collector_type": 0,
				"sensor_type": 100,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			},
			{
				"active": true,
				"category": "Solar Radiation",
				"created_date": 1571922396,
				"elevation": 0,
				"latitude": 25.346254,
				"longitude": 55.420933,
				"lsid": 265140,
				"manufacturer": "Davis Instruments",
				"modified_date": 1571922396,
				"parent_device_id": 9569897,
				"parent_device_id_hex": "001D0A920669",
				"parent_device_name": "Node 1",
				"parent_device_type": "Node",
				"port_number": 4,
				"product_name": "Solar Radiation",
				"product_number": "6450",
				"rain_collector_type": 0,
				"sensor_type": 144,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			},
			{
				"active": true,
				"category": "Leaf Wetness",
				"created_date": 1572261564,
				"elevation": 0,
				"latitude": 25.346254,
				"longitude": 55.420933,
				"lsid": 265814,
				"manufacturer": "Davis Instruments",
				"modified_date": 1572261564,
				"parent_device_id": 9570307,
				"parent_device_id_hex": "001D0A920803",
				"parent_device_name": "Node 2",
				"parent_device_type": "Node",
				"port_number": 1,
				"product_name": "Leaf Wetness Sensor",
				"product_number": "6420",
				"rain_collector_type": 0,
				"sensor_type": 104,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			},
			{
				"active": true,
				"category": "Wind",
				"created_date": 1572261694,
				"elevation": 0,
				"latitude": 25.346254,
				"longitude": 55.420933,
				"lsid": 265816,
				"manufacturer": "LCJ Captuers",
				"modified_date": 1572261694,
				"parent_device_id": 9570307,
				"parent_device_id_hex": "001D0A920803",
				"parent_device_name": "Node 2",
				"parent_device_type": "Node",
				"port_number": 2,
				"product_name": "Sonic-Anemo-DZP",
				"product_number": "",
				"rain_collector_type": 0,
				"sensor_type": 260,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			},
			{
				"active": true,
				"category": "Temp/Hum",
				"created_date": 1572261957,
				"elevation": 0,
				"latitude": 25.346254,
				"longitude": 55.420933,
				"lsid": 265817,
				"manufacturer": "Davis Instruments",
				"modified_date": 1572261957,
				"parent_device_id": 9570307,
				"parent_device_id_hex": "001D0A920803",
				"parent_device_name": "Node 2",
				"parent_device_type": "Node",
				"port_number": 3,
				"product_name": "Temp/Hum Sensor",
				"product_number": "6830",
				"rain_collector_type": 0,
				"sensor_type": 100,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			},
			{
				"active": true,
				"category": "Temperature",
				"created_date": 1572262016,
				"elevation": 0,
				"latitude": 25.346254,
				"longitude": 55.420933,
				"lsid": 265818,
				"manufacturer": "Davis Instruments",
				"modified_date": 1572262016,
				"parent_device_id": 9570307,
				"parent_device_id_hex": "001D0A920803",
				"parent_device_name": "Node 2",
				"parent_device_type": "Node",
				"port_number": 4,
				"product_name": "Temperature Probe",
				"product_number": "6477",
				"rain_collector_type": 0,
				"sensor_type": 107,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			},
			{
				"active": true,
				"category": "Soil Moisture",
				"created_date": 1572262955,
				"elevation": 0,
				"latitude": 25.346254,
				"longitude": 55.420933,
				"lsid": 265824,
				"manufacturer": "Decagon",
				"modified_date": 1572262955,
				"parent_device_id": 9569775,
				"parent_device_id_hex": "001D0A9205EF",
				"parent_device_name": "Node 3",
				"parent_device_type": "Node",
				"port_number": 1,
				"product_name": "5TM",
				"product_number": "",
				"rain_collector_type": 0,
				"sensor_type": 112,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			},
			{
				"active": true,
				"category": "Wind",
				"created_date": 1572263137,
				"elevation": 0,
				"latitude": 25.346254,
				"longitude": 55.420933,
				"lsid": 265825,
				"manufacturer": "LCJ Captuers",
				"modified_date": 1572263137,
				"parent_device_id": 9569775,
				"parent_device_id_hex": "001D0A9205EF",
				"parent_device_name": "Node 3",
				"parent_device_type": "Node",
				"port_number": 2,
				"product_name": "Sonic-Anemo-DZP",
				"product_number": "",
				"rain_collector_type": 0,
				"sensor_type": 260,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			},
			{
				"active": true,
				"category": "Temp/Hum",
				"created_date": 1572263216,
				"elevation": 0,
				"latitude": 25.346254,
				"longitude": 55.420933,
				"lsid": 265826,
				"manufacturer": "Davis Instruments",
				"modified_date": 1572263216,
				"parent_device_id": 9569775,
				"parent_device_id_hex": "001D0A9205EF",
				"parent_device_name": "Node 3",
				"parent_device_type": "Node",
				"port_number": 3,
				"product_name": "Temp/Hum Sensor",
				"product_number": "6830",
				"rain_collector_type": 0,
				"sensor_type": 100,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			},
			{
				"active": true,
				"category": "Temperature",
				"created_date": 1572361483,
				"elevation": 0,
				"latitude": 25.346254,
				"longitude": 55.420933,
				"lsid": 266179,
				"manufacturer": "Davis Instruments",
				"modified_date": 1572361483,
				"parent_device_id": 9569775,
				"parent_device_id_hex": "001D0A9205EF",
				"parent_device_name": "Node 3",
				"parent_device_type": "Node",
				"port_number": 4,
				"product_name": "Temperature Probe",
				"product_number": "6477",
				"rain_collector_type": 0,
				"sensor_type": 107,
				"station_id": 79092,
				"station_name": "Drought Garden Sharjah"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/data/initialState.json
// module id = 128
// module chunks = 0